
import global from '@/utils/global'
import { defineComponent } from 'vue'
import { getDispatchExamine, cancelDispatchExamine, getCompanyList } from '@/api/long-insure'
import { BillDetailDto, BillDto } from '@/api/bill'

import { insureDispatchList, insureDispatchDelete, addDispatch } from '@/api/insure-deduction'
import { queryPageListApi, queryAvailableOccupationApi, queryByIdApi, queryOccupationRecordApi } from '@/api/long-insure-new'
import { queryStaffRecordListApi, getAxServeCompanyIdApi } from '@/api/insure-daily-ax'
import { ElMessage, ElMessageBox } from 'element-plus'

import { formatter, downloadBlobFile } from '../utils/util'
import dayjs from 'dayjs'
import DialogAddCompany from './components/long-insure-dispatch/DialogAddCompany.vue'
import insureAxDispatchDrawer from './components/drawer/insureAxDispatchDrawer.vue'
// import { lastApplyOccupationStatusList } from '../api/insure-daily-ax-dict'
import { lastApplyOccupationStatusList, auditStatusList, policyStatusList } from '../utils/insure-daily-ax-dict'

export default defineComponent({
  name: 'InsureDailyCompany',
  components: {
    DialogAddCompany,
    insureAxDispatchDrawer
  },
  data() {
    return {
      formatter,
      formSearch: {
        serveCompanyName: ''
      },
      searchText: '',
      searchValue: '',
      pageSize: 10,
      pageNum: 1,
      total: 0,
      staffRecordPage: 1,
      staffRecordSize: 10,
      staffRecordTotal: 0,
      tableData: [],
      showAddCompany: false,
      curCompanyId: 0,
      curId: 0,
      addType: 'add', // 'add' 添加被派遣单位 'apply' 申请新工种
      showWorkerLevel: false, // 可用工种
      showPeopleInsure: false, // 在保人数抽屉
      peopleInsureList: [], // 在保人数
      rowId: '',
      selects: [] as string[], // 列表选中
      peopleFormSearch: {
        searchUserInfo: ''
      },
      serveCompanyInfo: {
        serveCompanyName: '北京中净餐具清洗服务有限公司'
      } as {
        serveCompanyName: string
      },
      companyDetail: {} as any,
      auditRecordList: [] as any,
      lastApplyOccupationStatusList,
      auditStatusList,
      policyStatusList
    }
  },
  created() {
    this.initTableList()
  },
  watch: {},
  methods: {
    async initTableList() {
      console.log(this.formSearch)
      const result = await queryPageListApi({
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        insureType: 8,
        serveCompanyName: this.formSearch.serveCompanyName
      })
      this.total = result.totalCount
      this.tableData = result.list
    },
    onSearch() {
      this.pageNum = 1
      this.initTableList()
    },
    onReset() {
      this.formSearch = {
        projectTime: ''
      }
      this.onSearch()
    },
    handleSizeChange() {
      this.pageNum = 1
      this.initTableList()
    },
    // 添加派遣单位
    onCompanyAdd() {
      this.addType = 'add'
      this.showAddCompany = true
    },
    // 根据派遣单位id导出在保人员
    async onDetailExport() {
      const res = await getAxServeCompanyIdApi(this.rowId, 'company')
      downloadBlobFile(res)
    },
    // 点击在保人数
    async onClickNum(row) {
      console.log('点击在保人数', row)
      this.showPeopleInsure = true
      this.rowId = row.serveCompanyId
      this.initPeopleInsureList()
    },
    // 点击可用工种
    async onClickWork(row) {
      console.log('点击可用工种', row.id, row)
      this.companyDetail = row
      this.showWorkerLevel = true
    },

    goBack() {
      this.showWorkerLevel = false
      this.showPeopleInsure = false
    },

    getStatusClass(status) {
      return {
        'status-pass': status === '通过',
        'status-reject': status === '驳回',
        'status-waiting': status === '待审核'
      }
    },
    handlePreview(file) {
      // 处理附件预览逻辑
      console.log('预览文件:', file)
      // 实际项目中可以调用文件预览接口或打开新窗口
    },

    // 在保人数查询
    onPeopleInsureSearch() {
      this.initPeopleInsureList()
    },
    handleStaffRecordSizeChange() {
      this.staffRecordPage = 1
      this.initPeopleInsureList()
    },
    onPeopleInsureReset() {
      this.peopleFormSearch = {
        searchUserInfo: ''
      }
      this.onPeopleInsureSearch()
    },
    peopleInsureSizeChange() {
      this.pageNum = 1
      this.initPeopleInsureList()
    },
    // 安心日保 当前 派遣单位id 投保人员-分页查询
    async initPeopleInsureList() {
      console.log(this.rowId)

      const result = await queryStaffRecordListApi({
        pageSize: this.staffRecordSize,
        pageNum: this.staffRecordPage,
        serveCompanyId: this.rowId,
        searchUserInfo:this.peopleFormSearch.searchUserInfo,
        policyStatus: 1
      })
      this.staffRecordTotal = result.totalCount
      this.peopleInsureList = result.list
    },
    // 检查在保结束时间，如果是2099-01-01则显示"结案断保"
    checkInsureEndTime(insureEndTime: string) {
      if (!insureEndTime) return '长期有效'
      // 使用 dayjs 判断日期是否为 2099-01-01
      const endDate = dayjs(insureEndTime).format('YYYY-MM-DD')
      return endDate === '2099-01-01' ? '结案断保' : insureEndTime
    }
  }
})
